import { useMutation } from 'react-query'
import { AxiosError } from 'axios'
import { qaBackendApiInstance } from '../config/config'
import { message } from 'antd'
import CryptoJS from 'crypto-js'

export interface IVerifyOTP {
  phone: string
  fp: string
  otp: string
}

interface VerifyOtpResponse {
  message?: string
  [key: string]: any
}

function encryptData(data: unknown) {
  const secret = process.env.REACT_APP_ENCRYPT_SECRET_KEY || ''
  if (!secret) {
    throw new Error('Missing encryption key. Set REACT_APP_ENCRYPT_SECRET_KEY')
  }

  const key = CryptoJS.SHA256(secret)
  const iv = CryptoJS.lib.WordArray.random(16)
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
    iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  })
  const ctBase64 = CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
  const ivBase64 = CryptoJS.enc.Base64.stringify(iv)
  return `${ivBase64}:${ctBase64}`
}

const mutationFn = async (payload: IVerifyOTP): Promise<VerifyOtpResponse> => {
  const endpoint = '/auth/verify-otp'
  const encoded = encryptData(payload)
  const response = await qaBackendApiInstance.post(endpoint, { encoded })
  return response.data
}

export const useVerifyOTP = () => {
  return useMutation(mutationFn, {
    onError: (err: AxiosError<{ message?: string }>) => {
      if (err.response?.status !== 401) {
        let errorMessage = 'Unable to verify OTP. Please try again.'
        if (err.response?.status === 400) {
          errorMessage = err.response.data?.message || 'Invalid OTP or input. Please check and try again.'
        } else if (err.response?.status === 429) {
          errorMessage = 'Too many attempts. Please wait a while before trying again.'
        } else if (err.response?.status === 500) {
          errorMessage = 'OTP verification service is currently unavailable. Please try again later.'
        }

        message.error(errorMessage)
      }
    },
  })
}
